import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO MI REVERSIÓN BIOLÓGICA — ACCESO INMEDIATO POR $47',
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior: open the checkout cart in a new tab.
      // window.open with _blank is reliable inside sandboxed previews,
      // where direct window.location navigation can be blocked.
      window.open('https://shop.minhealthgroup.com/cart/50878347378855:1', '_blank', 'noopener,noreferrer');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative w-full md:w-auto inline-flex items-center justify-center gap-3 bg-emerald text-marble px-6 md:px-10 py-5 rounded-lg font-bold text-base md:text-lg shadow-soft-lg hover:bg-emerald-light border border-emerald-light transition-all duration-300 ${className}`} data-id="element-7">
      <span className="text-center" data-id="element-8">{text}</span>
      <ArrowRight className="w-6 h-6 text-gold group-hover:translate-x-1 transition-transform shrink-0 hidden sm:block" data-id="element-9" />
    </motion.button>;
}